import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISingleIdParams } from '../../../ts/ServerApi/types/actionParams';

export class ResumeSubscriptionRequest extends Request<ISingleIdParams, IEmptyResult> {
  constructor(id: string) {
    super('resumeSubscription', {
      id: id
    });
  }
}

